<nav class="navbar top-nav navbar-expand-lg navbar-dark p-2">
  <div class="container-fluid">
    <div class="contact-information d-flex align-items-center">
      <div class="contact-number me-4">
        <div class="call-icon d-flex align-items-center">
          <img src="./../../../assets/images/phone rings.svg" alt="call-icon" />
          <a href="tel:+919059013838" style="text-decoration: none; color: #ffffff;">
            <h5 class="mb-0 ms-2 forResposiveness">+91 9059013838</h5>
          </a>
        </div>
      </div>
      <div class="contact-email" (click)="openGmail()" style="cursor: pointer;">
        <div class="email-icon d-flex align-items-center">
          <img src="./../../../assets/images/email.svg" alt="email-icon" />
          <h5 class="mb-0 ms-2 forResposiveness">info&#64;digiworldexpo.com</h5>
        </div>
      </div>
    </div>

    <div class="top-menu-rightside for-tab ms-auto d-flex align-items-center">
      <div class="dropdown account-icon me-4" #dropdownRef (mouseenter)="toggleDropdown(true)"
        (mouseleave)="toggleDropdown(false)" (touchstart)="toggleDropdown(true)" (click)="toggleDropdown(true)">
        <button href="#" class="d-flex align-items-center my-account" role="button" id="accountDropdownMenuLink"
          aria-expanded="false">
          <img src="./../../../assets/images/user round.svg" alt="account-icon" />
          <h5 class="mb-0 ms-2 text-white forResposiveness">
            MY&nbsp;ACCOUNT {{ isLoggedin ? "| " + userName : "" }}
          </h5>
          <img class="dropdownarrow-black ms-2" src="./../../../assets/images/angle arrow small down.svg"
            alt="arrow-down-icon" />
        </button>

        <div class="isloggedin signin" *ngIf="!isLoggedin">
          <ul class="dropdown-menu  text-center" [ngClass]="{ show: isDropdownOpen }"
            aria-labelledby="accountDropdownMenuLink">
            <div class="mt-4" style="margin-top: 4px;">
              <li><a (click)="onSignInClick()" class="links signIn-button">Sign in</a></li>
            </div>
            <li>
              <div class=" d-flex align-items-center justify-content-center mt-3">
                <p class="mt-2 sign-text " style="cursor: none; margin-left: 4px;">New to Medworld Expo?</p>
                <a [routerLink]="['/user/signup']" class="links sign-text mb-1"> &nbsp;<b>Join Now</b></a>
              </div>
            </li>
          </ul>
        </div>
        <div class="isloggedin" *ngIf="isLoggedin">
          <ul class="dropdown-menu text-center" [ngClass]="{ show: isDropdownOpen }"
            aria-labelledby="accountDropdownMenuLink">
            <li (click)="navigateByRole()">
              <div class="m-2 d-flex gap-3 align-items-center">
                <img class="ms-3" src="/assets/images/user.svg" alt="My Dashboard" />
                {{ roleName === 'USER' ? 'My Profile' : 'My Dashboard' }}
              </div>
            </li>
            <li (click)="openAllNotifications()">
              <div class="m-2 d-flex gap-3 align-items-center">
                <img class="ms-3" src="\assets\images\white-bell.svg" alt="Account settings" />
                Notifications

              </div>
            </li>
            <li>
              <div class="m-2 d-flex mb-2 gap-3 align-items-center" (click)="logout()">
                <img class="ms-3" src="/assets/images/log out.svg" alt="Logout" />
                Logout
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="dropdown language-selection me-4" #languageDropdown (mouseenter)="toggleLanguageDropdown(true)"
        (mouseleave)="toggleLanguageDropdown(false)" (touchstart)="toggleLanguageDropdown(true)"
        (click)="toggleLanguageDropdown(true)">
        <button href="#" class="d-flex align-items-center my-account" role="button" id="languageDropdownMenuLink">
          <img src="./../../../assets/images/earth.svg" alt="language-icon" />
          <h5 class="mb-0 ms-2" style="color: white;">
            {{ selectedLanguage === "cn" ? "中文" : "ENGLISH" }}
          </h5>
          <img class="dropdownarrow-black ms-2" src="./../../../assets/images/angle arrow small down.svg"
            alt="arrow-down-icon" />
        </button>
        <ul class="dropdown-menu text-center" [ngClass]="{ show: isLanguageDropdownOpen }"
          aria-labelledby="languageDropdownMenuLink">
          <li>
            <a class="dropdown-item languageItem" (click)="selectLanguage('en')"
              [class.active]="selectedLanguage === 'en'">ENGLISH</a>
          </li>
          <li>
            <a class="dropdown-item languageItem" (click)="selectLanguage('cn')"
              [class.active]="selectedLanguage === 'cn'">CHINESE</a>
          </li>
        </ul>
      </div>

      <button class="btn btn-dark d-flex align-items-center responsive-btn" routerLink="/signup">

        <h5 class="mb-0 forResposiveness" style="font-size: 14px; color: black;">Exhibit With Us</h5>
      </button>
    </div>
  </div>
</nav>

<nav class="navbar-expand-lg main-nav" [class.isAppleDevice]="isDeviceTypeApple">

  <div class="container-fluid">
    <div class="row align-items-center navheight">
      <div class="col-2 top-menu-leftside d-flex flex-row " style="cursor: pointer">

        <img *ngIf="!isResponsiveSearch" class="medworldexpoLogo" src="./../../../assets/images/logomedworld32full.svg"
          alt="medworldexpo" style="height: 50px; padding-left: 25px;" [routerLink]="['/']" />

        <div class="d-block d-sm-none m-2 ">
          <div class="dropdown language-selection" #languageDropdown (click)="isMobileLanguageDropDown()">

            <button href="#" class="d-flex align-items-center my-account mt-1" role="button"
              id="languageDropdownMenuLink">
              <img src="./../../../assets/images/icons/earth-black.svg" alt="language-icon" />
              <h5 class="mb-0 ms-1 text-black">
                {{ selectedLanguage === "cn" ? "中文" : "ENGLISH" }}
              </h5>
              <img class="dropdownarrow-black ms-1" src="./../../../assets/images/angle arrow small down.svg"
                alt="arrow-down-icon" />
            </button>
            <ul class="dropdown-menu languageBarrier text-center" [ngClass]="{ show: isLanguageDropdownOpen }"
              aria-labelledby="languageDropdownMenuLink">
              <li>
                <a class="dropdown-item languageItem" (click)="selectLanguage('en')"
                  [class.active]="selectedLanguage === 'en'">ENGLISH</a>
              </li>
              <li>
                <a class="dropdown-item languageItem" (click)="selectLanguage('cn')"
                  [class.active]="selectedLanguage === 'cn'">CHINESE</a>
              </li>
            </ul>
          </div>
        </div>
        <img class="more" (click)="responsiveMore()" src="../../../../assets/images/menu.svg" alt=""
          style="border: none; ">
      </div>
      <app-universal-search  class="d-block d-sm-none m-2 search-box "></app-universal-search>
    <!-- <div style="width: 100%; display: flex; align-items: center; " class="d-block d-sm-none m-2 search-box ">
        <div class="" style="z-index: 1000;">
          <div class="search-wrapper">
            <mat-icon _ngcontent-ng-c91545049="" id="searchicon" role="img" matprefix="" style="padding-right: 15px"
              class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color ng-tns-c1607617776-78"
              aria-hidden="true" data-mat-icon-type="font">search</mat-icon>
            <input id="search" class="custom-input" type="search" placeholder="Search Products, Brands and Webinars"
              aria-label="Search" [(ngModel)]="searchTerm" (input)="search(searchTerm)" autocomplete="off" />
          </div>

          <div *ngIf="showDropdown" class="dropdown-menu search show mobileViewSearch forScrollingMobile"
            style="width: auto;">
            <div class="container">
              <div class="row d-flex">
                <div class="col-md-6" *ngIf="products?.length">
                  <div *ngIf="products?.length">
                    <h5 class="dropdown-header">Products</h5>
                    <a class="dropdown-item" (click)="navigateTo(['/product-details', product.id])"
                      *ngFor="let product of products">{{ product.name | truncateText: 28 }}</a>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="filteredCategories.length">
                  <div *ngIf="filteredCategories.length">
                    <h5 class="dropdown-header">Categories</h5>
                    <a class="dropdown-item" (click)="navigateTo(['/category', category.id])"
                      *ngFor="let category of filteredCategories">{{ category.name | truncateText: 28 }}</a>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="oems.length">
                  <div *ngIf="oems.length">
                    <h5 class="dropdown-header">Brands</h5>
                    <a class="dropdown-item" style="cursor: pointer" (click)="navigateToBrandProfile(oem.id)"
                      *ngFor="let oem of oems">{{ oem.name | truncateText: 28 }}</a>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="webinars.length">
                  <div *ngIf="webinars.length">
                    <h5 class="dropdown-header">Webinars</h5>
                    <a class="dropdown-item" style="cursor: pointer" (click)="navigateToWebinar(webinar.id)"
                      *ngFor="let webinar of webinars">{{ webinar.name | truncateText: 28 }}</a>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div> -->


      <div class="col-3 top-menu-rightside">
        <!-- <div class="search-wrapper">
          <mat-icon id="searchicon" role="img" style="padding-right: 15px"
            class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true"
            data-mat-icon-type="font">search</mat-icon>
          <input id="search" class="custom-input" type="search" placeholder="Search Products, Brands and Webinars"
            aria-label="Search" #searchInput (input)="search(searchInput.value)" autocomplete="off" />
        </div> -->
  <app-universal-search></app-universal-search>
        <!-- <div *ngIf="showDropdown" class="dropdown-menu search show forScrolling">
          <div class="container drop-container">
            <div class="row d-flex dropdown-columns">
              <div class="col-md-3 column-item0 " *ngIf="products?.length">
                <h5 class="dropdown-header">Products</h5>
                <div class="product-list-item">
                  <a class="dropdown-item" (click)="navigateTo(['/product-details', product.id])"
                    *ngFor="let product of products">{{ product.name | truncateText: 18 }}</a>
                </div>
              </div>

              <div class="col-md-3 column-item1" *ngIf="filteredCategories?.length">
                <h5 class="dropdown-header">Categories</h5>
                <div class="product-list-item">
                  <a class="dropdown-item" (click)="navigateTo(['/category', category.id])"
                    *ngFor="let category of filteredCategories">{{ category.name | truncateText: 18 }}</a>
                </div>
              </div>

              <div class="col-md-3 column-item2" *ngIf="oems?.length">
                <h5 class="dropdown-header">Brands</h5>
                <div class="product-list-item">
                  <a class="dropdown-item" style="cursor: pointer" (click)="navigateToBrandProfile(oem.id)"
                    *ngFor="let oem of oems">{{ oem.name | truncateText: 18 }}</a>
                </div>
            </div>

            <div class="col-md-3 column-item2" *ngIf="distributors?.length">
              <h5 class="dropdown-header">Distributor</h5>
              <div class="product-list-item">
                <a
                class="dropdown-item"
                style="cursor: pointer"
                (click)="navigateToDistributorProfile(distributor.id)"
                *ngFor="let distributor of distributors"
              >{{ distributor.name | truncateText: 18 }}</a>
              </div>
          </div>
            <div class="col-md-3 column-item3" *ngIf="webinars?.length">
                <h5 class="dropdown-header">Webinars</h5>
                <div class="product-list-item">
                  <a class="dropdown-item" style="cursor: pointer" (click)="navigateToWebinar(webinar.id)"
                    *ngFor="let webinar of webinars">{{ webinar.name | truncateText: 18}}</a>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>


      <div class="col-7 navheight trapezoid top-menu-rightside">
        <div class="d-flex justify-content-around align-items-center h-100 ml-10ms-3"
          style="margin-left: 68px;text-align: center;">
          <div class="p-2 position-relative header-option nav-header-tabs" #CategoriesDropdown
            (mouseenter)="toggleCategoryDropdown(true)" (mouseleave)="toggleCategoryDropdown(false)"
            (touchstart)="toggleCategoryDropdown(true)" (click)="toggleCategoryDropdown(true)">
            {{ "PRODUCTS" | translate }}

            <div>
              <ul class="dropdown-menu" [ngClass]="{ show: isCategoryDropdownOpen, 'd-none': !isCategoryDropdownOpen }"
                aria-labelledby="CategoriesDropdownMenuLink" style="
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 5px;
              position: absolute;
              left: 50%;
              top: 100%;
              transform: translateX(-50%);
              z-index: 1000;
              background-color: #ffffff;  
              border: 1px solid #ccc; 
              padding: 10px; 
            ">
                <li *ngFor="let category of categories" style="list-style-type: none;">
                  <a class="dropdown-item" (click)="onCategorySelect(category)" href="javascript:void(0)">
                    {{ category.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>


          <div class="white-line"></div>
          <div class="p-2 header-option nav-header-tabs" [routerLink]="['/brands']">
            {{ "BRANDS" | translate }}
          </div>
          <div class="white-line"></div>
          <div class="p-2 header-option nav-header-tabs" [routerLink]="['/website-distributor']">
            {{ "DISTRIBUTORS" | translate }}
          </div>

          <div class="white-line"></div>
          <div class="p-2  header-option nav-header-tabs" #HealthCenterDropdown
            (mouseenter)="toggleHealthCenterDropdown(true)" (mouseleave)="toggleHealthCenterDropdown(false)"
            (touchstart)="toggleHealthCenterDropdown(true)" (click)="toggleHealthCenterDropdown(true)">
            {{ "HEALTHCARE NETWORK" | translate }}
            <div>
              <ul class="dropdown-menu" [ngClass]="{ show: isHealthCenterDropdownOpen }"
                aria-labelledby="HealthCenterDropdownMenuLink">
                <li *ngFor="let health of HealthCenterList">
                  <div class="dropdown-item" (click)="onHealthCenterSelect(health);closeDropdownMenuInCurrentPage()">
                    {{ health }}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="white-line"></div>
          <div class="p-2 header-option nav-header-tabs" #newsAndInsightsDropdown
            (mouseenter)="toggleNewsAndInsightsDropdown(true)" (mouseleave)="toggleNewsAndInsightsDropdown(false)"
            (touchstart)="toggleNewsAndInsightsDropdown(true)" (click)="toggleNewsAndInsightsDropdown(true)">
            {{ "NEWS_TRENDS" | translate }}
            <div>
              <ul class="dropdown-menu" [ngClass]="{ show: isNewsAndInsightsDropdownOpen }"
                aria-labelledby="NewsAndInsightsMenuLink">
                <li *ngFor="let news of NewsAndInsightsList">
                  <div class="dropdown-item" (click)="navigateToNews(news);closeDropdownMenuInCurrentPage()">
                    {{ news }}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="white-line"></div>
          <div class="p-2  header-option nav-header-tabs" #KnowledgeCenterDropdown
            (mouseenter)="toggleKnowledgeCenterDropdown(true)" (mouseleave)="toggleKnowledgeCenterDropdown(false)"
            (touchstart)="toggleKnowledgeCenterDropdown(true)" (click)="toggleKnowledgeCenterDropdown(true)">
            {{ "KNOWLEDEGE_CENTER" | translate }}
            <div>
              <ul class="dropdown-menu knowledgCenterDropDownForIpad"
                [ngClass]="{ show: isKnowledgeCenterDropdownOpen }" aria-labelledby="KnowledgeCenterDropdownMenuLink"
                style="margin-left: -35px;">
                <li *ngFor="let knowledge of KnowledgeCenterList">
                  <div class="dropdown-item"
                    [routerLink]="(knowledge === 'Webinars')?['/webinars']: (knowledge === 'Conferences/ CME')? ['/conferences']: (knowledge === 'Blogs & Community')? ['/blogs']: (knowledge === 'E-Magazines')? ['/magazines']: ['/journals']  "
                    [state]="{ knowledge: knowledge }" (click)="closeDropdownMenuInCurrentPage()">
                    {{ knowledge }}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="white-line"></div>
          <div class="p-2 header-option nav-header-tabs" [routerLink]="['/jobs']">
            {{ "JOBS" | translate }}
          </div>
        </div>
      </div>

      <div class="menu-section" *ngIf="responsiveMoreOptions" (click)="closeTheHamburgerMenu()">
        <div class="responsiveMenu" *ngIf="responsiveMoreOptions" (click)="isInsideMenu()">
          <div>
            <div class="pointer d-flex justify-content-end ">
              <img src="../../assets/images/icons/cross.svg" alt="close" class="cross-icon"
                (click)="closeResponsiveBar()">
            </div>
            <div class="products pointer ">
              <div class="products-dropdown" (click)="barOptions('products')">
                <h4 [ngClass]="{'text-blue': barActiveContent.includes('products')}">Products</h4>

                <img *ngIf="!barActiveContent.includes('products')" src="\assets\images\dropdown_arrow.svg" alt="">

                <img *ngIf="barActiveContent.includes('products')" src="\assets\images\dropdown_arrow_blue.svg" alt="">
              </div>

              <div class="disable-global-css" *ngIf="barActiveContent.includes('products')">
                <ul
                  style="box-sizing: initial !important; scrollbar-width: auto !important; scrollbar-color: initial !important;">
                  <li *ngFor="let category of categories" style="list-style-type: none;">
                    <div (click)="closeResponsiveBar()" class="dropdown-item" [routerLink]="['/category', category.id]"
                      [state]="{ category: category, isViewAll: false}">
                      {{ category.name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>


            <div class="products pointer " (click)="closeTheHamburgerMenu() ">
              <h4 [routerLink]="['/brands']">Brands</h4>
            </div>
            <div class="products pointer " (click)="closeTheHamburgerMenu() ">
              <h4 [routerLink]="['/website-distributor']">Distributor</h4> 
            </div>
            <!-- <div class="products pointer ">
              <div class=" Health-Centers-dropdown">
              <h4>Health Centers</h4> 
              <img src="\assets\images\dropdown_arrow.svg" (click)="barOptions('healthServices')" alt="">
              </div>
              <div *ngIf="barActiveContent.includes('healthServices')" >
                  <ul>
                    <li *ngFor="let health of HealthCenterList">
                      <div
                        class="dropdown-item"
                        (click)="onHealthCenterSelect(health); closeResponsiveBar();"
                      >
                        {{ health }}
                      </div>
                    </li>
                  </ul>
                </div>
            </div> -->
            <div class="products pointer">
              <div class="Health-Centers-dropdown" (click)="barOptions('healthServices')">
                <h4 [ngClass]="{'text-blue': barActiveContent.includes('healthServices')}">Health Centers</h4>

                <img *ngIf="!barActiveContent.includes('healthServices')" src="\assets\images\dropdown_arrow.svg"
                  alt="">

                <img *ngIf="barActiveContent.includes('healthServices')" src="\assets\images\dropdown_arrow_blue.svg"
                  alt="">
              </div>

              <div class="disable-global-css" *ngIf="barActiveContent.includes('healthServices')">
                <ul
                  style="box-sizing: initial !important; scrollbar-width: auto !important; scrollbar-color: initial !important;">
                  <li *ngFor="let health of HealthCenterList">
                    <div class="dropdown-item" (click)="onHealthCenterSelect(health); closeResponsiveBar();">
                      {{ health }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>




            <div class="products pointer">
              <div class="newsSights-dropdown" (click)="barOptions('newsSights')">
                <h4 [ngClass]="{'text-blue': barActiveContent.includes('newsSights')}">News & Insights</h4>


                <img *ngIf="!barActiveContent.includes('newsSights')" src="\assets\images\dropdown_arrow.svg" alt="">

                <img *ngIf="barActiveContent.includes('newsSights')" src="\assets\images\dropdown_arrow_blue.svg"
                  alt="">
              </div>

              <div class="disable-global-css" *ngIf="barActiveContent.includes('newsSights')">
                <ul
                  style="box-sizing: initial !important; scrollbar-width: auto !important; scrollbar-color: initial !important;">
                  <li *ngFor="let news of NewsAndInsightsList">
                    <div class="dropdown-item" (click)="navigateToNews(news); closeResponsiveBar();">
                      {{ news }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>


            <div class="products pointer">
              <div class="knowledgeCenter-dropdown" (click)="barOptions('knowledgeCenter')">
                <h4 [ngClass]="{'text-blue': barActiveContent.includes('knowledgeCenter')}">Knowledge Center</h4>
                <img *ngIf="!barActiveContent.includes('knowledgeCenter')" src="\assets\images\dropdown_arrow.svg"
                  alt="">

                <img *ngIf="barActiveContent.includes('knowledgeCenter')" src="\assets\images\dropdown_arrow_blue.svg"
                  alt="">

              </div>

              <div class="disable-global-css" *ngIf="barActiveContent.includes('knowledgeCenter')">
                <ul
                  style="box-sizing: initial !important; scrollbar-width: auto !important; scrollbar-color: initial !important;">
                  <li *ngFor="let knowledge of KnowledgeCenterList">
                    <div (click)="closeResponsiveBar()" class="dropdown-item" [routerLink]="['/webinars']"
                      [state]="{ knowledge: knowledge }">
                      {{ knowledge }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>


            <div class="products pointer " (click)="closeTheHamburgerMenu()">
              <h4 [routerLink]="['/jobs']" >Jobs</h4> 
            </div>
          </div>
          <br>
          <div>
            <div class="exhibit" routerLink="/signup" style="font-weight: bold;">
              Exhibit with us
            </div>
            <div *ngIf="!roleName" class="login" routerLink="/login" style="font-weight: bold;">
              Login
            </div>
            <div *ngIf="roleName" class="login" (click)="logout()" style="font-weight: bold;">
              Logout
            </div>
            <div class="account" routerLink="/dashboard/super-admin" *ngIf="roleName === 'SUPER_ADMIN'">
              <img src="../../assets/images/icons/account-icon.svg" alt="user">
              My Account
            </div>
            <div class="account" routerLink="/dashboard/oem" *ngIf="roleName === 'OEM'">
              <img src="../../assets/images/icons/account-icon.svg" alt="user">
              My Account
            </div>
            <div class="account" routerLink="/dashboard/distributor" *ngIf="roleName === 'DISTRIBUTOR'">
              <img src="../../assets/images/icons/account-icon.svg" alt="user">
              My Account
            </div>
            <div class="account" *ngIf="roleName === 'USER'" (click)="navigateToCustomerProfile()" >
              <img src="../../assets/images/icons/account-icon.svg" alt="user">
              My Account
            </div>
            <div class="account" routerLink="/user/signup" *ngIf="!roleName"
              style="text-align: center; display: flex; flex-direction: column;">
              <span style="color: black;">New to MedWorldExpo?</span>
              <span style="text-decoration: underline;">Join Now</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<div class="badge-square">
  <span class="badge-text" (click)="navigateToSupport()">Get Support</span>
</div>